import { ColumnTypeEnum } from '../../enums/column-type-enum';

export interface Column {
  key: string;
  displayName: string;
  type: ColumnTypeEnum;
  buttonIcon?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action?: (data: any) => void;
  sortField: string;
  columnWidthPercentage : string;
}
